import { useState } from "react";
import { mediaUrl } from "lib/media";

export default function GalleryCard({ item, height = 240, onClick }) {
  const [hov, setHov] = useState(false);
  const img = mediaUrl(item.image);
  return (
    <div
      onMouseEnter={() => setHov(true)}
      onMouseLeave={() => setHov(false)}
      onClick={onClick}
      title={item.label}
      className="rounded-xl overflow-hidden cursor-pointer relative transition-[transform,box-shadow] [transition-duration:250ms]"
      style={{
        gridColumn: `span ${item.span || 1}`,
        background: item.color,
        height,
        transform: hov ? "scale(1.025)" : "scale(1)",
        boxShadow: hov ? "0 12px 36px rgba(0,0,0,0.4)" : "none",
      }}
    >
      {img ? (
        <img
          src={img}
          alt={item.label}
          loading="lazy"
          className="absolute inset-0 w-full h-full object-cover"
        />
      ) : (
        <>
          <svg
            className="absolute inset-0 w-full h-full opacity-10"
            viewBox="0 0 400 240"
            preserveAspectRatio="xMidYMid slice"
          >
            <circle cx="200" cy="120" r="100" fill="#fff" />
            <circle cx="60" cy="40" r="50" fill="#fff" />
            <circle cx="360" cy="200" r="60" fill="#fff" />
          </svg>
          <div className="absolute inset-0 flex items-center justify-center text-4xl opacity-30">
            📷
          </div>
        </>
      )}
      {/* No caption overlay — the photo shows clean. The label lives on as the
          image's alt text and the tile's tooltip, so it stays accessible. */}
      {hov && <div className="absolute inset-0 bg-black/20 transition-colors" />}
    </div>
  );
}
